module.exports = __webpack_public_path__ + "img/brasao-gerente-master.10153752.png";